import { render, staticRenderFns } from "./yi-upload.vue?vue&type=template&id=e8c9d4e6&scoped=true&"
import script from "./yi-upload.vue?vue&type=script&lang=js&"
export * from "./yi-upload.vue?vue&type=script&lang=js&"
import style0 from "./yi-upload.vue?vue&type=style&index=0&id=e8c9d4e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8c9d4e6",
  null
  
)

component.options.__file = "src/components/yi-upload/yi-upload.vue"
export default component.exports